export enum ControlTypes {
  Textbox,
  Dropdown,
  Textarea,
  RichTextarea,
  MultiRelationship,
  SingleRelationship,
  Label,
  Radio,
  MultiSelect,
  Checkbox,
  MultiSelectCheckbox
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/forms/models/form/control-types.ts